import styled from 'styled-components';
import css from 'styled-jsx/css';

const SaveStripMixin = css`
  margin-right: 4px;
  background-image: url(https://images.myloapp.in/NestJsUploads/1734601756846-save-x-1.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 33%;
  padding: 2px 12px 2px 12px;
  border-radius: 0 2px 2px 0;
  color: #fff;
  font-size: 12px;
`;
const SaveStripMixinB = css`
  display: inline-block;
  background-color: #63b0a8;
  color: #fff;
  padding: 1px 6px;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
`;
const productNameMixin = css`
  font-weight: 500;
  font-size: 13px;
  color: hsl(0deg, 0%, 0%, 78%);
  overflow: hidden;
  padding: 4px 0 0;
  width: 100%;
`;
export const SaveComboTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  padding-bottom: 16px;
`;

export const RelativeDiv = styled.div`
  position: relative;
  margin: ${(props) =>
    props.showNewDiaperVariantUx ? '20px 16px 0px 16px' : '20px 12px 0px'};
`;

export const ComboCardContainer = styled.a`
  display: flex;
  flex-shrink: ${(props) => (props.single ? '1' : '0')};
  width: ${(props) => (props.single ? '100%' : 'auto')};
`;

export const CardScrollDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    display: none;
  }

  scroll-behavior: smooth;
`;

export const ScrollArrow = styled.div`
  position: absolute;
  left: ${(props) => (props.left ? '10px' : '')};
  right: ${(props) => (props.right ? '0px' : '')};
  cursor: pointer;
  z-index: 9;
  background: #f2f2f29c;
  padding: 4px;
  border-radius: 3px;
  transition: background 0.2s ease-in-out;
  display: ${(props) => (props.visible ? 'block' : 'none')};

  @media (max-width: 720px) {
    display: none;
  }

  &:hover {
    background: #f2f2f2;
  }
`;

export const VermArrow = styled.img`
  width: 14px;
  height: 14px;
  transform: ${(props) => props.rotate};
`;

export const ScrollContainer = styled.div`
    display: flex;
    align-items: normal;
    transform: translateX(${(props) => props.xValue + 'px'});
    transition: transform 0.3s ease;
    width: 100%;

    & .thumb:first-child {
        margin-left: ${(props) => (props.allReviews ? '10px !important' : '')};
    }

    @media (max-width: 720px) {
        display: ${(props) =>
          props.nomWebScroll || props.isForNewCdPage ? 'grid' : 'flex'};
        grid-template-columns: repeat(auto-fill, 50%);
        grid-template-rows: auto auto;
`;

export const DoubleScrollContainer = styled.div`
  grid-template-rows: auto auto;
  grid-auto-columns: 20%;
  grid-auto-flow: column;
  align-items: normal;
  justify-content: center;
  transform: translateX(${(props) => props.xValue + 'px'});
  transition: transform 0.3s ease;
  width: 100%;
  @media (max-width: 720px) {
    grid-auto-columns: 43%;
    grid-auto-flow: ${(props) => (props.showVerticalGrid ? 'row' : 'column')};
    grid-template-columns: ${(props) =>
      props.showVerticalGrid ? 'repeat(auto-fill,50%)' : 'unset'};
  }
  display: grid;
`;

export const ComboCard = styled.div`
  flex-shrink: 0;
  max-width: ${(props) => (props.isUAE ? '312px' : '285px')};
  border: 1px solid hsl(0deg, 0%, 0%, 10%);
  padding: ${(props) => (!props.userType ? '4px 8px' : '0 0 12px')};
  margin: 0 8px;
  border-radius: 6px;
  display: ${(props) => (!props.userType ? 'flex' : '')};
  align-items: ${(props) => (!props.userType ? 'center' : '')};

  @media (max-width: 720px) {
    max-width: ${(props) =>
      props.single ? '100%' : props.isUAE ? '312px' : '285px'};
  }

  .leftSection {
    img {
      // width: 78px;
      // height: 78px;
      border-radius: 4px;
    }
  }

  .rightSection {
    margin-left: 12px;
  }

  .flexSection {
    display: flex;
    align-items: start;
    padding: 12px 8px 4px;
  }

  ul {
    padding-top: 6px;
    list-style: disc outside;
    padding-left: 10px;

    li {
      font-size: 10px;
      font-weight: normal;
      text-align: left;
      color: rgb(0, 0, 0, 0.54);
      list-style-position: outside;
    }
  }

  @media (min-width: 720px) {
    cursor: pointer;
  }

  &:nth-child(1) {
    margin-left: 0;
  }
`;

export const ProductName = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  overflow: hidden;
  width: 100%;
  ${(props) => !props.userType && productNameMixin}
`;

export const SaveSticker = styled.div`
  ${(props) => (props.userType ? SaveStripMixin : SaveStripMixinB)}
`;
